import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { DetialStructure, CitizenData } from '../../common/Models/CitizenModels';
import { environment } from '../../../environments/environment.development';
import { map, Observable } from 'rxjs';
import { AadharOtpResponse, AadharOtpVerifyResponse, citizenattributeoldnewvalueResponse, mobileResponse, RationcardResponse } from '../../common/Models/AadharVerifyModel';
import { EncryptionService } from '../../common/services/encryption.service';

@Injectable({
  providedIn: 'root',
})
export class CitizenService {
  constructor(private http: HttpClient,protected encryptionService: EncryptionService) { }

  // Api EndPoints

  urlGetDetailsStructure: string = environment.MasterAPI + 'Citizen/GetDetailPageStructure';
  urlGetCitizenData: string = environment.MasterAPI + 'Citizen/GetCitizenData';
  urlGetUpdatedCitizenData: string = environment.MasterAPI + 'Citizen/GetUpdatedCitizenData';
  urlFinalSubmit: string = environment.MasterAPI + 'Citizen/FinalSubmit';
  urlGetCitizenGrievance: string = environment.GrievanceAPI + 'Grievance/GetCitizenGrievance';
  urlUpdateCitizenGrievance: string = environment.GrievanceAPI + 'Grievance/UpdateGrievance';
  urlDownaloadAttachmentsFromGrievance: string = environment.GrievanceAPI + 'Grievance/DownloadAttachement?fileName=';

  urlGoogleBucketEndPoint: string = environment.CommonAPI + "Backet/Add";
  urlEditGoogleBucketEndPoint: string = environment.CommonAPI + "Backet/Edit";
  urlDeleteGoogleBucketEndPoint: string = environment.CommonAPI + "Backet/Delete";
  urlGetAttrubuteParameter: string = environment.MasterAPI + 'Citizen/GetAttrubuteParameter';

  urlSaveAttrubuteParameter: string = environment.MasterAPI + 'Citizen/SaveAttrubuteParameter';

  // My Dashboard
  // urlMyDashboardTickets:string = environment.CMSAPI + 'SchemeCreation/GetCitizenMyDashboard?';
  urlsubmitCitizenScheme: string = environment.CMSAPI + 'SchemeCreation/SubmitCitizenScheme';
  urldocumentUpload: string = environment.CommonAPI + 'backet/add';
  urlMyDashboardTickets: string = environment.CMSAPI + 'SchemeCreation/GetCitizenMyDashboard?citizenuid=';
  urlSchemeSuggestionAttributeList: string = environment.CMSAPI + 'SchemeCreation/GetSchemeDetailCitizen?datacheckid=3';
  urlgetAppliedSchemeDetails: string = environment.CMSAPI + 'SchemeCreation/GetCitizenAppliedSchemeForm';
  urlgetSuggestedSchemesFromDepartment: string = environment.CMSAPI + 'SchemeCreation/GetSuggestedSchemeDataForMobile';

  // urlDepartmentNameList:string = environment.CMSAPI + 'Department/GetDepartment';
  urlDepartmentNameList: string = environment.CMSAPI + 'Common/GetDropDownData';
  urlsubmitSeekforClarification: string = environment.CMSAPI + 'SchemeScrutiny/UpdateSchemeAppStatus';
  urlSchemeSaveAsDraft: string = environment.MasterAPI + 'Citizen/SchemeSaveAsDraft';
  urlgetSaveAsDraftSchemeDetails: string = environment.MasterAPI + 'Citizen/GetSaveAsDraftSchemeDetails';
  urlgetSavedSchemeDetails: string = environment.MasterAPI + 'Citizen/GetSavedSchemeDetails';
  urlUpdateSaveAsDraftSchemeStatus: string = environment.MasterAPI + 'Citizen/UpdateSaveAsDraftSchemeStatus';
  urlGetPivotFormBuilder: string = environment.MasterAPI + 'Citizen/GetPivotFormBuilder';
  urlSendAadharMobileOTP: string = environment.MasterAPI + 'AadhaarAuthentication/GetVerifyAadhaarNumber';
  urlVerifyAadharMobileOTP: string = environment.MasterAPI + 'AadhaarAuthentication/GetAadhaarDetailsOTP';
  urlvleDashboardCount: string = environment.CMSAPI + 'UserDashboard/GetVLEUserDashBoardCard';
  urlvleDashboardChartCount: string = environment.CMSAPI + 'UserDashboard/GetVLEUserDashBoardGraphChart';
  //urleMudraRegistrationVLE:string = 'https://dev-emudhra.amnex.co.in/emIDAMAPI/masterApiUserCreation.htm';
  urleMudraRegistrationVLE: string =environment.DepartmentSSOAPI+'Auth/AddUserDetail'; //'https://departmentssoauthapi.amnex.co.in/api/Auth/AddUserDetail';
  urlsaveCitizenDetail: string = environment.MasterAPI + 'Citizen/VarifiedAttrubuteDetails';
  //urlSaveUserMasterDetails: string = environment.MasterAPI + 'Citizen/SaveUserMasterDetails';
  urlStoreGRRecords: string = environment.MasterAPI + 'Mobile/StoreGoldenRecordData';
 // urlCitizenUserData: string = environment.MasterAPI + 'Citizen/CitizenUserData';
  urlGetAadharVaultKey: string = environment.MasterAPI + 'AadhaarAuthentication/GetVaultKey?aadhaarNumber=';
  urlGetUserMasterData: string = environment.MasterAPI + 'Citizen/GetCitizenUserMasterData?aadharRefno=';
  urlCitizeneMudraRegistrationVLE: string = environment.AuthApi + '/auth/EmudhraRegistration';
  urlgetVLESchemeDetails: string = environment.CMSAPI + 'SchemeScrutiny/GetApplicationDataForVLE?vleuserid=';
  urlGetSchemeAttributeDetails: string = environment.CMSAPI + 'SchemeCreation/GetSchemeAttributeDetails';

  urlGetFamilyDetails: string = environment.MasterAPI + 'Family/GetFamilyDetails';
  urlGenerateFamilyKey: string = environment.MasterAPI + 'Family/GenerateFamilyKey';
  urlGetTempCities: string = environment.MasterAPI + 'Citizen/GetCities';
  urlGetTpsConsentRequest: string = environment.ConsentManagerAPI + 'ConsentManager/GetConsentRequest'
  urldepartmentusernotification: string = environment.CMSAPI + 'Notification/SetUserNotifByDept';
  urlUpdateAadharData: string = environment.MasterAPI + 'Mobile/UpdateAadharData';
  urlGetFamilyCardDetails: string = environment.MasterAPI + 'Family/getFamilyCardDetails';
  urlverifyCasteInfo: string = environment.MasterAPI + 'Mobile/VerifyCaste';

  urlGet_Citizen_Aattribute_Details: string = environment.MasterAPI + 'Citizen/Get_Citizen_Aattribute_Details';
  urlCitizen_Attribute_Submit: string = environment.MasterAPI + 'Citizen/Citizen_Attribute_Submit';

  urldigilockerpulldocument: string = environment.MasterAPI + 'CitizenDigitalLocker/Pulldocument';
  //urlExistingScheme: string = environment.NicApi + 'ApiDashboard/GetSchemeDetails';
  urlExistingScheme: string = environment.MasterAPI + 'Family/GetSchemeDetails';

  // urlExistingScheme: string = environment.NicApi + 'ApiDashboard/GetSchemeDetails';
  urlCitizen_Attribute_Submit_SD: string = environment.MasterAPI + 'Citizen/Citizen_Attribute_Submit_SD';
  urlGet_Citizen_Attribute_Details: string = environment.MasterAPI + 'Citizen/Get_Citizen_Attribute_Details';

  urlGet_Rationcard_Number: string = environment.MasterAPI + 'Family/GetRationcard';

  urlGetRegistrationDetailsByVLE: string = environment.MasterAPI + 'Citizen/GetRegistrationDetailsByVLE';

  urlNewUserRegister: string = environment.MasterAPI + 'Citizen/NewUserRegister';
  urlGetLandingPageCount: string = environment.MasterAPI + 'Citizen/GetCitizenLandingPageCount';
  urlInsertVisitor: string = environment.MasterAPI + 'Citizen/InsertVisitor';
  urlCountVisitor: string = environment.MasterAPI + 'Citizen/GetCountVisitor';

  urlVerifyMemberIdDetails: string = environment.MasterAPI + 'AadhaarAuthentication/GetVerifyMemberIdDetails';
  urlRationcardvisitodetails: string = environment.MasterAPI + 'Citizen/Rationcardvisitodetails';

  urlVerifyRationcardaadharnumber: string = environment.MasterAPI + 'AadhaarAuthentication/GetVerifyRationcardaadharnumber';
  urlSendekycAadharMobileOTP: string = environment.MasterAPI + 'AadhaarAuthentication/GetVerifyekycAadhaarNumber';


  urlekycVerifyAadharMobileOTP: string = environment.MasterAPI + 'AadhaarAuthentication/GetekycAadhaarDetailsOTP';

  urlGetMobilenoBySevaarthId: string = environment.MasterAPI + 'AadhaarAuthentication/GetMobilenoBySevaarthId';

  urlGetEkyclogData: string = environment.MasterAPI + 'Profile/GetEkyclogData';

  urlGet_Family_Annual_Income_Details: string = environment.MasterAPI + 'Citizen/Get_Family_Annual_Income_Details';

  urlGetCitizenAttributeOldNewValue: string = environment.MasterAPI + 'Citizen/GetCitizenAttributeOldNewValue';
  urlGetSectionmasterDetails: string = environment.MasterAPI + 'Citizen/GetSectionmasterDetails';
  Citizen_Attribute_Submit_SD(body: any) {
    return this.http.post(
      this.urlCitizen_Attribute_Submit_SD,
      body,
      {
        headers: {
          'Content-Type': 'application/json',
          'citizen_unique_id': body.citizen_unique_id   // 👈 ADD THIS
        }
      }
    );
  }

  Get_Citizen_Attribute_Details(body: any) {
    return this.http.post(
      this.urlGet_Citizen_Attribute_Details,
      body,
      {
        headers: {
          'Content-Type': 'application/json',
          'citizen_unique_id': body.citizen_unique_id   // 👈 ADD THIS
        }
      }
    );
  }
  getExistingScheme(Body: any) {
    return this.http.post(this.urlExistingScheme, Body);
  }
  getGoldenRecordFixedAttributeData(Body: any) {
    return this.http.post(this.urlGetAttrubuteParameter, Body);
  }

  getDetailsStructure(Body: DetialStructure) {
    return this.http.post(this.urlGetDetailsStructure, Body);
  }

  getCitizenData(Body: CitizenData) {
    return this.http.post(this.urlGetCitizenData, Body);
  }

  getUpdaetedCitizenData(Body: CitizenData) {
    return this.http.post(this.urlGetUpdatedCitizenData, Body);
  }

  getFinalSubmit(Body: CitizenData) {
    return this.http.post(this.urlFinalSubmit, Body);
  }

  getCitizenGrievance(Body) {
    return this.http.post(this.urlGetCitizenGrievance, Body);
  }

  updateCitizenGrievance(Body) {
    return this.http.post(this.urlUpdateCitizenGrievance, Body);
  }

  downloadGrievanceAttachment(fileName: string) {
    return this.http.get(this.urlDownaloadAttachmentsFromGrievance + fileName, { responseType: 'blob' });
  }

  AddGoogleBucket(Body: any) {
    return this.http.post(this.urlGoogleBucketEndPoint, Body);
  }

  EditGoogleBucket(Body: any) {
    return this.http.post(this.urlEditGoogleBucketEndPoint, Body);
  }

  DeleteGoogleBucket(Body: any) {
    return this.http.post(this.urlDeleteGoogleBucketEndPoint, Body);
  }

  submitFinalAttribute(Body: any) {
    return this.http.post(this.urlFinalSubmit, Body);
  }
  getAttrubuteParameter(Body: DetialStructure) {
    return this.http.post(this.urlGetAttrubuteParameter, Body);
  }
  saveAttrubuteParameter(Body: DetialStructure) {
    return this.http.post(this.urlSaveAttrubuteParameter, Body);
  }
  getSchemeAttributeDetails(body: any) {
    return this.http.post(this.urlGetSchemeAttributeDetails, body);
  }
  getCustomDropdown(url) {
    return this.http.get(url);
  }
  getMyDashboardTickets(citizen_unique_id: string) {
    return this.http.get(this.urlMyDashboardTickets + citizen_unique_id);
  }
  submitCitizenScheme(body: any) {
    return this.http.post(this.urlsubmitCitizenScheme, body);

  }
  documentUpload(Body: any) {
    return this.http.post(this.urldocumentUpload, Body);
    //return this.http.post('https://mhucdh-citizenapi.amnex.co.in/gateway/backet/add',Body);
  }
  attributedocumentUpload(Body: any) {
    return this.http.post(this.urlGoogleBucketEndPoint, Body);
    //return this.http.post('https://mhucdh-citizenapi.amnex.co.in/gateway/backet/add',Body);
  }


  getSchemeSuggestionAttributeList() {
    return this.http.get(this.urlSchemeSuggestionAttributeList);
  }
  getSuggestedSchemesFromDepartment(Body: any) {
    return this.http.post(this.urlgetSuggestedSchemesFromDepartment, Body);
  }
  getDepartmentNameList(Body: any) {
    return this.http.post(this.urlDepartmentNameList, Body);
  }
  getAppliedSchemeDetails(body: any) {
    return this.http.post(this.urlgetAppliedSchemeDetails, body);
  }
  getSeekForClarificationSchemeDetails(body: any) {
    return this.http.post(this.urlgetAppliedSchemeDetails, body);
  }
  submitSeekForClarification(body: any) {
    return this.http.post(this.urlsubmitSeekforClarification, body);
  }
  onSaveAsDraft(body: any) {
    return this.http.post(this.urlSchemeSaveAsDraft, body);
  }
  getSaveAsDraftSchemeDetails(Body: any) {
    return this.http.post(this.urlgetSaveAsDraftSchemeDetails, Body);
  }
  getSavedSchemeDetails(Body: any) {
    return this.http.post(this.urlgetSavedSchemeDetails, Body);
  }
  onUpdateSaveAsDraftSchemeStatus(body: any) {
    return this.http.post(this.urlUpdateSaveAsDraftSchemeStatus, body);
  }
  GetPivotFormBuilder(Body: DetialStructure) {
    return this.http.post(this.urlGetPivotFormBuilder, Body);
  }
 sendAadharMobileOTP(aadhar: string, userType: string,rationRefNo?:string): Observable<AadharOtpResponse> {
  const params = new HttpParams()
    .set('aadhaarNumber', aadhar)
    .set('userType', userType)
    .set('rationRefNo', rationRefNo);
  return this.http.post<AadharOtpResponse>(
    this.urlSendAadharMobileOTP,
    {},
    { params: params }
  );
}
  verifyAadharMobileOTP(Body: AadharOtpVerifyResponse) {
    return this.http.post(this.urlVerifyAadharMobileOTP, Body);
  }
  vleDashboardCount(Body: any) {
    return this.http.post(this.urlvleDashboardCount, Body);
  }
   vleDashboardCountNEW(Body: any) {
    return this.http.post(this.urlvleDashboardCount, Body);
  }
  vleDashboardChartCount(Body: any) {
    return this.http.post(this.urlvleDashboardChartCount, Body);
  }
  // eMudraRegistrationVLE(Body:any) {
  //   var body = JSON.stringify(Body);
  //   return this.http.post(this.urleMudraRegistrationVLE,body);
  // }
  eMudraRegistrationVLE(Body: any) {
    var body = JSON.stringify(Body);
    const header = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'accept': 'application/json'
      })
    }
    return this.http.post(this.urleMudraRegistrationVLE, body, { headers: header.headers });
  }
  varifiedAttrubuteDetails(body: any) {
    return this.http.post(this.urlsaveCitizenDetail, body);
  }
  // citizenUserData(body: any) {
  //   return this.http.post(this.urlCitizenUserData, body);
  // }
  storeGRRecord(body: any) {
    return this.http.post(this.urlStoreGRRecords, body);
  }
  getAadharVaultKey(aadharNumber: string) {
    return this.http.get(this.urlGetAadharVaultKey + aadharNumber);
  }
  getAadharVaultKeyNew(aadharNumber: string) {
  const body = {
    aadhaarNumber: aadharNumber
  };

  return this.http.post<any>(`${environment.MasterAPI}AadhaarAuthentication/GetVaultKeyV1`, body);
}
  getUserMasterData(aadharRefno: string) {
    return this.http.get(this.urlGetUserMasterData + aadharRefno);
  }
  citizeneMudraRegistrationVLE(Body: any) {
    var body = JSON.stringify(Body);
    const header = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': '*'
      })
    };
    return this.http.post(this.urlCitizeneMudraRegistrationVLE, body, { headers: header.headers });
  }
  getVLESchemeDetails(vleuserid: string) {
    return this.http.get(this.urlgetVLESchemeDetails + vleuserid);
  }

  // Family Module Endpoints
  getFamilyDetails(Body: any) {
    return this.http.post(this.urlGetFamilyDetails, Body);
  }
  getFamilyCardDetails(body: any) {
    return this.http.post(this.urlGetFamilyCardDetails, body);
  }

  generateFamilyKey(Body: any) {
    return this.http.post(this.urlGenerateFamilyKey, Body);
  }
  getTempCities(): Observable<any> {
    return this.http.get(this.urlGetTempCities);
  }
  getTPSConsentRequest(citizen_unique_id: string) {
    const params = new HttpParams().set('citizen_unique_id', citizen_unique_id);
    return this.http.get(this.urlGetTpsConsentRequest, { params });
  }

  senddepartmentusernotification(body: any) {
    return this.http.post(this.urldepartmentusernotification, body);
  }
  updateAadharData(body: any) {
    return this.http.post(this.urlUpdateAadharData, body);
  }
  verifyCasteInfo(body: any) {
    return this.http.post(this.urlverifyCasteInfo, body);
  }
  fn_Get_Citizen_Aattribute_Details(Body: DetialStructure) {
    return this.http.post(this.urlGet_Citizen_Aattribute_Details, Body);
  }
  public fn_DownloadPDFProfile(data: any) {
    return this.http.post(environment.MasterAPI + 'Family/DownloadPDFRationcardDetails', data, {
      responseType: 'blob' as 'json'   // 👈 important fix
    });
  }

  fn_Citizen_Attribute_Submit(Body: any) {
    return this.http.post(this.urlCitizen_Attribute_Submit, Body);
  }
  // digilockerpulldocument(body: any) {
  //   return this.http.post(this.urldigilockerpulldocument, body);
  // }
  openDigitalLocker(requestData: any) {
    return this.http.post(environment.CommonAPI + 'DigiLocker/AuthLogin', requestData);
    // return this.http.post<any>(environment.CommonAPI + 'DigiLocker/AuthLogin',requestData)
    //   .pipe(map((result: any) => {
    //     return result;
    //   }));
  }
  GetDigiLockerDocuments(accessToken: any) {
    return this.http.get(environment.CommonAPI + 'DigiLocker/Documents?accessToken=' + accessToken);
    // return this.http.post<any>(environment.CommonAPI + 'DigiLocker/AuthLogin',requestData)
    //   .pipe(map((result: any) => {
    //     return result;
    //   }));
  }
  GetCertificateDatainXML(accessToken: any, uri: any) {
    return this.http.get(environment.CommonAPI + 'DigiLocker/GetCertificateDatainXML?accessToken=' + accessToken + '&uri=' + uri);
    // return this.http.post<any>(environment.CommonAPI + 'DigiLocker/AuthLogin',requestData)
    //   .pipe(map((result: any) => {
    //     return result;
    //   }));
  }
  UploadToDigiLocker(body: any) {
    return this.http.post(environment.CommonAPI + 'DigiLocker/UploadToDigiLocker', body);
    //return this.http.post('https://mhucdh-citizenapi.amnex.co.in/gateway/backet/add',Body);
  }
  //     getExistingScheme(Body: any) {
  //   return this.http.post(this.urlExistingScheme, Body);
  // }
  fn_Get_Rationcard_number(data: any) {
    return this.http.post(this.urlGet_Rationcard_Number, data);
  }


  GetDrivingLicenseNumber(accessToken: any) {
    return this.http.get(environment.CommonAPI + 'DigiLocker/GetDrivingLicenseNumber2?accessToken=' + accessToken);
    // return this.http.post<any>(environment.CommonAPI + 'DigiLocker/AuthLogin',requestData)
    //   .pipe(map((result: any) => {
    //     return result;
    //   }));
  }



  Get12thPercentage(accessToken: any) {
    return this.http.get(environment.CommonAPI + 'DigiLocker/Get12thPercentage?accessToken=' + accessToken);
    // return this.http.post<any>(environment.CommonAPI + 'DigiLocker/AuthLogin',requestData)
    //   .pipe(map((result: any) => {
    //     return result;
    //   }));
  }

  Get10thPercentage(accessToken: any) {
    return this.http.get(environment.CommonAPI + 'DigiLocker/Get10thPercentage?accessToken=' + accessToken);
    // return this.http.post<any>(environment.CommonAPI + 'DigiLocker/AuthLogin',requestData)
    //   .pipe(map((result: any) => {
    //     return result;
    //   }));
  }

  getDocumentValue(accessToken: string, flag: string) {
    return this.http.get(
      environment.CommonAPI + 'DigiLocker/GetDocumentValue',
      {
        params: {
          accessToken,
          flag
        }
      }
    );
  }

   fn_GetRegistrationDetailsByVLE(body: any) {
    return this.http.post(this.urlGetRegistrationDetailsByVLE, body);
  }
  fn_NewUserRegister(body: any) {
    return this.http.post(this.urlNewUserRegister, body);
  }
  getGetLandingPageCount() {
    return this.http.get(this.urlGetLandingPageCount);
  }
  getip() {
    return this.http.get('https://api.ipify.org?format=json');

  }
  insertVisitor(body: any) {
    return this.http.post(this.urlInsertVisitor, body);
  }
  GetCountVisitor() {
    return this.http.get(this.urlCountVisitor);
  }
  sendVerifyMemberIdDetails(memberid: string, ipaddress: string): Observable<AadharOtpResponse> {
    const params = new HttpParams()
      .set('memberid', memberid)
      .set('ipaddress', ipaddress);

    return this.http.post<AadharOtpResponse>(
      this.urlVerifyMemberIdDetails,
      {},
      { params: params }
    );
  }
  Rationcardvisitodetails(body: any) {
    return this.http.post(this.urlRationcardvisitodetails, body);
  }
  VerifyRationcardadhhar(aadhar: string): Observable<RationcardResponse> {
    const params = new HttpParams()
      .set('aadhaarNumber', aadhar);

    return this.http.post<RationcardResponse>(
      this.urlVerifyRationcardaadharnumber,
      {},
      { params: params }
    );
  }

  send_ekycAadharMobileOTP(aadhar: string, userType: string,adharreffkey: string,  actionType?: string): Observable<AadharOtpResponse> {
    const params = new HttpParams()
      .set('aadhaarNumber', aadhar)
      .set('userType', userType)
      .set('adharreffkey', adharreffkey)
      .set('actionType', actionType);


    return this.http.post<AadharOtpResponse>(
      this.urlSendekycAadharMobileOTP,
      {},
      { params: params }
    );
  }

  send_ekycverifyAadharMobileOTP(Body: AadharOtpVerifyResponse) {
    return this.http.post(this.urlekycVerifyAadharMobileOTP, Body);
  }



  public GetEkyclogData(data: any) {
    const payload = {
    username: '',
    citizen_unique_id: data.citizen_unique_id
    };
    return this.http.post<any>(this.urlGetEkyclogData,  payload)
      .pipe(map((result: any) => {
        return result;
      }));
  }

  GetMobilenoBySevaarthId(sevarthId: string): Observable<mobileResponse[]> {
    const params = new HttpParams()
      .set('SevaarthId', sevarthId);

    return this.http.post<mobileResponse[]>(
      this.urlGetMobilenoBySevaarthId,
      {},
      { params: params }
    );
  }
  Get_Family_Annual_Income_Details(body: any) {
    return this.http.post(
      this.urlGet_Family_Annual_Income_Details,
      body,
      {
        headers: {
          'Content-Type': 'application/json',
          'citizen_unique_id': body.citizen_unique_id   // 👈 ADD THIS
        }
      }
    );
  }
  GetCitizenAttributeOldNewValue(  citizen_unique_id: string ): Observable<citizenattributeoldnewvalueResponse> {

    return this.http.post<citizenattributeoldnewvalueResponse>(
      this.urlGetCitizenAttributeOldNewValue,
      {
        citizen_unique_id: citizen_unique_id
      }
    );
  }

    getGetSectionMaster() {
    return this.http.get(this.urlGetSectionmasterDetails);
  }
}
